import { Outlet, createFileRoute } from "@tanstack/react-router"
import { AccessAwareError } from "~/components/reusable/errors/AccessAwareError"
import { internalRouteGuard } from "~/utils/routeGuards"

/** Hakio-internal settings pages. The nav hides them from customers; this guard also blocks opening them by URL. */
export const Route = createFileRoute("/_auth/settings/_layout/_internal")({
  beforeLoad: internalRouteGuard,
  component: Outlet,
  errorComponent: AccessAwareError,
})
